module.exports = "/images/vendor/flag-icon-css/flags/4x3/bd.svg?5102bab03db6e13a165043eedab1e332";